import IncentivizeIcon from 'assets/img/store/Incentivize_tips.svg';
import BoostIcon from 'assets/img/store/Boost_avg.svg';
import CheckoutIcon from 'assets/img/store/Faster-checkout.svg';
import BlogIcon from 'assets/img/store/treezPayVirtualTerminalBlog.png';
import { InfoCard } from 'components/stores/InfoCard';
import { SemiBold } from 'components/ui/semibold';
import { Icon } from 'components/ui/icon';

const UtilisationInfo = () => {
  const InfoPointObj = [
    {
      icon: BoostIcon,
      heading: 'Boost Average Order Value',
      subHeading: (
        <span>
          <SemiBold className="text-gray-blue-70">Increase AOV </SemiBold>
          by an average of{' '}
          <SemiBold className="text-gray-blue-70">20%</SemiBold> through the
          TreezPay integrated payment suite
        </span>
      ),
    },
    {
      icon: CheckoutIcon,
      heading: 'Faster Checkout',
      subHeading: (
        <span>
          <SemiBold className="text-gray-blue-70">Expedite </SemiBold>
          the checkout process through pushing payments directly through Treez
          POS
        </span>
      ),
    },
    {
      icon: IncentivizeIcon,
      heading: 'Incentivize upselling through tips',
      subHeading: (
        <span>
          Boost morale and incentivize upselling by enabling{' '}
          <SemiBold className="text-gray-blue-70">
            integrated payment tipping
          </SemiBold>{' '}
          functionality
        </span>
      ),
    },
  ];

  return (
    <div className="hidden lg:flex w-1/2 max-w-3xl bg-light-green-bg items-center justify-center mx-auto">
      <div className="px-16 xl:px-24">
        <div className="flex flex-col mb-8 gap-5">
          {InfoPointObj.map((item, ind) => {
            return (
              <InfoCard key={ind} icon={item.icon}>
                <h2 className="text-base font-semibold leading-5 text-gray-blue-90 mb-1">
                  {item.heading}
                </h2>
                <h3 className="text-sm font-normal leading-4 text-gray-blue-70">
                  {item.subHeading}
                </h3>
              </InfoCard>
            );
          })}
        </div>

        <div>
          <div className="mb-2 text-sm font-medium text-dark-gray">
            Take payments anytime, anywhere -
          </div>
          <div className="block mb-3 text-sm font-normal leading-5 text-gray-blue-70">
            The <SemiBold>TreezPay Virtual Terminal</SemiBold> lets budtenders
            accept <SemiBold>card, tap-to-pay, and ACH</SemiBold> from any
            browser, with <SemiBold>no extra hardware</SemiBold>. Run overflow
            lanes, curbside, delivery, and pop-ups with every payment synced to{' '}
            <SemiBold>Treez reporting</SemiBold> and backed by{' '}
            <SemiBold>15+ processors</SemiBold> for failover.
          </div>

          <div className="flex items-center gap-3 p-4 bg-white rounded-lg">
            <span className="shrink-0">
              <img
                src={BlogIcon}
                alt="TreezPay Virtual Terminal"
                className="w-16 h-16 rounded object-contain"
              />
            </span>
            <span className="inline-grid">
              <span className="text-sm font-medium leading-4 text-gray-blue-90 mb-2">
                Introducing the TreezPay Virtual Terminal
              </span>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.treez.io/blog/introducing-the-treezpay-virtual-terminal"
                className="text-dark-green-link text-sm font-medium leading-4 flex items-center mt-2 hover:underline"
              >
                Read here
                <Icon
                  name="arrow-right"
                  className="pl-1"
                  size={16}
                  aria-hidden="true"
                />
              </a>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UtilisationInfo;
